var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EventApplication',{attrs:{"title":"기간별 응모 수","action":"totalCount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }